import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './HeroSectionSlider.css';
import { Link } from 'react-router-dom';

const HeroSectionSlider = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const slides = [
        { image: '/Assets/SliderIamges/slide1.1.webp' },
        { image: '/Assets/SliderIamges/slide2.2.webp' },
        { image: '/Assets/SliderIamges/slide3.3.webp' },
        { image: '/Assets/SliderIamges/slide4.4.webp' },
        { image: '/Assets/SliderIamges/slide5.5.webp' },
        { image: '/Assets/SliderIamges/slide6.6.webp' },
        { image: '/Assets/SliderIamges/slide7.7.webp' },
        { image: '/Assets/SliderIamges/slide8.8.webp' }
    ];

    return (
        <div className="hero-slider">
            <Swiper
                modules={[Navigation, Autoplay]}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop
                speed={200}
                slidesPerView={1}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                onInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.navigation.init();
                    swiper.navigation.update();
                }}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="slide">
                            <img src={slide.image} alt={`Slide ${index + 1}`} draggable="false" />
                            <Link to="/products" className="learn-more-btn">LEARN MORE</Link>
                        </div>
                    </SwiperSlide>
                ))}

                <div className="custom-swiper-button-prev" ref={prevRef}>‹</div>
                <div className="custom-swiper-button-next" ref={nextRef}>›</div>
            </Swiper>
        </div>
    );
};

export default HeroSectionSlider;
